function MuseumIntro() {
  return (
    <section className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:px-8">
      <div>
        <p className="text-xs uppercase tracking-[0.32em] text-museum-gold">The exhibition</p>
        <h2 className="mt-4 font-display text-4xl text-museum-bone sm:text-5xl">Every room tells you something about being human.</h2>
      </div>
      <div className="glass-panel rounded-lg p-7">
        <p className="text-xl leading-9 text-museum-bone">
          Each room represents one fear.
        </p>
        <div className="my-6 h-px gold-line" />
        <p className="leading-8 text-museum-muted">
          Not as a monster. Not as a diagnosis. But as a human pattern: a signal, a memory, a defense, or a question.
        </p>
      </div>
    </section>
  );
}

export default MuseumIntro;
